import { actionCopyDa } from "./actionCopy";
import { listCopyDa } from "./listCopy";

export const patientsCopyDa = {
    patients: "Patienter",
    navPatientsDescription: "Administrer alle dine patienter ét sted.",
    patientFallback: "Patient",
    action: "Handling",
    trackerEntry: "Spørgeskemaindtastning",
    patientsError: "Patientfejl",
    error: "Fejl",
    tabActive: "Aktive",
    tabPending: "Afventende",
    tabInactive: "Inaktive",
    search: actionCopyDa.search,
    searchPatientsAria: "Søg efter patienter",
    searchForPatient: "Søg efter en patient",
    searchDescription: "Søg efter navn, e-mail, fødselsdato, hospitalsnummer eller dagbogsnavn",
    searchPlaceholder: "Søg efter navn, e-mail, fødselsdato, hospitalsnummer...",
    noResultsFound: "Ingen resultater fundet",
    trySearchingHint: "Prøv at søge efter navn, e-mail, fødselsdato eller hospitalsnummer",
    enterSearchTerm: "Angiv et søgeord for at finde patienter",
    loadingDiaries: "Indlæser dagbøger...",
    errorLoadingDiaries: (message: string) => `Fejl ved indlæsning af dagbøger: ${message}`,
    unknownPatient: "Ukendt patient",
    dateOfBirthLabel: "Fødselsdato",
    noDiariesOnPage: "Ingen dagbøger på denne side",
    showingDiaries: (start: number, end: number, total: number) => `Viser dagbøger ${start} til ${end} af ${total}`,
    patientsPerPage: "Patienter pr. side",
    emptyFirstPatientTitle: "Inviter din første patient",
    emptyFirstPatientDescription:
        "Vælg en dagbogsopsætning, gennemgå detaljerne, og send en invitation. Deres fremskridt vises her.",
    emptyFirstPatientCta: "Tilføj din første dagbog",
    emptyFirstPatientHelpLink: "Hvordan inviterer jeg en patient?",
    emptyTabTitle: (tabLabel: string) => `Ingen ${tabLabel.toLowerCase()} dagbøger`,
    emptyTabDescription: "Dagbøger under andre faner er stadig tilgængelige. Skift fane, eller inviter en ny patient.",
    notDefined: "Ikke defineret",
    columnDiaryStatus: "Dagbogsstatus",
    columnStartDate: "Startdato",
    columnPatientName: "Patientnavn",
    columnOrganisation: listCopyDa.organisation,
    columnLabels: listCopyDa.labels,
    columnDateOfBirth: listCopyDa.dateOfBirth,
    columnHospitalNumber: "Hospitalsnummer",
    columnRead: "Gennemgået",
    filters: actionCopyDa.filters,
    filterDiariesAria: "Filtrer dagbøger",
    viewSettings: "Visningsindstillinger",
    viewSettingsDescription:
        "Vælg dagbogsomfang, status, delte klinikere, etiketter og organisationsfiltre for denne liste.",
    sharedWithClinicians: "Delt med klinikere",
    diaryStatus: "Dagbogsstatus",
    selectStatuses: "Vælg statusser",
    labels: listCopyDa.labels,
    organisation: listCopyDa.organisation,
    save: actionCopyDa.save,
    apply: actionCopyDa.apply,
    sortDiariesTitle: "Sorter dagbøger",
    sortDiariesDescription:
        "Vælg felt og rækkefølge for denne liste. Sorteringen gælder for alle dagbøger under den aktuelle fane, ikke kun denne side.",
    diaryScope: "Dagbogsomfang",
    directAccess: "Direkte adgang",
    allDiariesInOrganisation: "Alle dagbøger i min organisation",
    selectClinicians: "Vælg klinikere",
    selectLabels: "Vælg etiketter",
    clearFilters: "Ryd filtre",
    selectOrganisations: "Vælg organisationer",
    sortDiariesAria: "Sorter dagbøger",
    sortBy: "Sorter efter",
    order: "Rækkefølge",
    sortAscending: "Stigende",
    sortDescending: "Faldende",
    sortState: "Status",
    sortStartDate: "Startdato",
    sortFirstName: "Fornavn",
    sortLastName: "Efternavn",
    sortDateOfBirth: "Fødselsdato",
    sortHospitalNumber: "Hospitalsnummer",
    read: "Gennemgået",
    unread: "Ikke gennemgået",
    noDiarySelected: "Ingen dagbog valgt",
    refreshDiary: "Opdater dagbog",
    noDiaryFound: "Ingen dagbog fundet.",
    diaryCouldNotLoad: "Dagbogen kunne ikke indlæses.",
    profileCouldNotLoad: "Profilen kunne ikke indlæses.",
    diaryDetails: "Dagbogsdetaljer",
    patientDetails: "Patientoplysninger",
    unknownState: "Ukendt status",
    none: actionCopyDa.none,
    edit: actionCopyDa.edit,
    done: actionCopyDa.done,
    contact: "Kontakt",
    noContactPerson: "Ingen kontaktperson",
    lastEntry: (relative: string) => `Seneste indtastning ${relative}`,
    diaryOrganisation: "Dagbogsorganisation",
    organisationAndContact: "Organisation og kontakt",
    editCareDetails: "Rediger plejeforløbsoplysninger",
    labelsStudyTrial: "Etiketter (studie/forsøg)",
    contactName: "Kontaktnavn",
    contactLabel: (name: string) => `Kontakt: ${name}`,
    nameLabel: "Navn",
    emailLabel: "E-mail",
    openLink: "Åbn link",
    dateRangeToNow: (start: string) => `${start} til nu`,
    dateRangeTo: (start: string, end: string) => `${start} til ${end}`,
    informationToComplete: "Oplysninger der skal udfyldes",
    clinicianTasks: (entryCount: number, formCount: number) =>
        `Du har ${entryCount === 1 ? "1 forfalden indtastning" : `${entryCount} forfaldne indtastninger`} i ${
            formCount === 1
                ? "1 formular, som teamet skal udfylde."
                : `${formCount} formularer, som teamet skal udfylde.`
        }`,
    completeNextForm: "Udfyld næste formular",
    completeForm: (title: string) => `Udfyld ${title}`,
    questionnaire: "Spørgeskema",
    more: actionCopyDa.more,
    moreActions: "Flere handlinger",
    moreActionsAria: "Flere handlinger",
    printDiary: "Udskriv dagbog",
    shareDiary: "Del dagbog",
    openFullScreen: "Åbn fuld skærm",
    messageHistory: "Beskedhistorik",
    deleteDiary: "Slet dagbog",
    deleteDiaryTitle: "Slet dagbog",
    deleteDiaryDescription: "Er du sikker på, at du vil slette denne dagbog?",
    cancel: actionCopyDa.cancel,
    delete: actionCopyDa.delete,
    updateDiary: "Opdater dagbog",
    addToDiary: "Tilføj til dagbog",
    addEvent: "Tilføj hændelse",
    addConsent: "Tilføj samtykke",
    addQuestionnaire: "Tilføj spørgeskema",
    addFromTemplate: "Tilføj fra skabelon",
    addEventDescription: "Tilføj en behandling og knyt den til en eksisterende dato, eller opret en ny.",
    addConsentDescription: "Knyt et samtykke til en behandling, eller tilføj et med sin egen dato.",
    addQuestionnaireDescription: "Tilføj et spørgeskema og knyt det til en eksisterende dato, eller opret en ny.",
    addFromTemplateDescription: "Anvend en gemt skabelon på denne dagbog.",
    addConsentTitle: "Tilføj samtykke",
    addConsentDescriptionLong: "Vælg en behandling, eller tilføj et samtykke med sin egen dato.",
    selectProcedureDate: "Behandling",
    notForAnEvent: "Ikke til en hændelse",
    consentDate: "Dato",
    noProcedureDatesForConsent: "Tilføj først en behandling.",
    addEventFirst: "Tilføj hændelse først",
    selectConsent: "Samtykke",
    selectConsentHelp: "Vælg et offentliggjort samtykke til denne dagbog.",
    noPublishedConsents:
        "Ingen offentliggjorte samtykker er tilgængelige. En admin kan offentliggøre et i samtykkebyggeren.",
    consentRoles: "Hvem skal underskrive",
    consentRolesHelp: "De valgte personer bliver bedt om at underskrive dette samtykke.",
    saveConsent: "Tilføj samtykke",
    savingConsent: "Tilføjer samtykke...",
    existingDateGroup: "Skete det på samme dato som",
    newDate: "Ikke en af datoerne ovenfor",
    newDateHelp: "",
    pickExistingDateHelp: "",
    markAsReviewed: "Markér som gennemset",
    endDiary: "Afslut dagbog",
    reinstate: "Genopret",
    contactPatient: "Kontakt patient",
    endDiaryTitle: "Afslut dagbog",
    endDiaryNotifyQuestion: "Vil du underrette patienten?",
    justEndDiary: "Afslut blot dagbogen",
    endDiaryAndNotify: "Afslut dagbog og underret patient",
    markReviewedTitle: "Markér som gennemset",
    markReviewedNotifyQuestion: "Vil du underrette patienten om, at hans/hendes dagbog er gennemset?",
    justMarkReviewed: "Markér blot som gennemset",
    notifyPatient: "Underret patient",
    from: "Fra",
    to: "Til",
    subject: "Emne",
    emailBody: "E-mailtekst",
    send: actionCopyDa.send,
    sending: actionCopyDa.sending,
    emailSentSuccess: "E-mail sendt",
    emailSentDescription: "Patienten er blevet underrettet",
    emailSendFailed: "Kunne ikke sende e-mail",
    seeYourPatients: "Se dine patienter",
    seeYourPatientsDescription: "Overvåg dine patienters fremskridt og administrer deres dagbøger",
    goToPatients: "Gå til patienter",
    goingToPatients: "Går til patienter...",
    reliableEmailWarning: "For pålidelig levering anbefaler vi Gmail, Outlook eller iCloud.",
    entryRecordedTitle: "Indtastning registreret",
    entryRecordedPending: (count: number) =>
        `Der ${count === 1 ? "er" : "er"} ${count} ${
            count === 1 ? "yderligere indtastning" : "yderligere indtastninger"
        } afventende for denne patient. Sørg for, at alle påkrævede vurderinger er gennemført.`,
    entryRecordedComplete:
        "Alle påkrævede indtastninger for denne patient er gennemført. Patientens journal er nu opdateret.",
    continueToNextEntry: "Fortsæt til næste indtastning",
    returnToPatient: "Tilbage til patient",
    loadingTemplates: "Indlæser skabeloner...",
    addToDiaryTitle: "Tilføj til dagbog",
    addToDiaryDescription: "Tilføj en behandling, et samtykke eller et spørgeskema, eller start fra en skabelon.",
    addManually: "Tilføj manuelt",
    addManuallyDescription: "Angiv behandlings- og spørgeskemaoplysninger trin for trin uden at bruge en skabelon.",
    chooseTemplate: "Vælg en skabelon",
    chooseTemplateDescription:
        "Vælg en gemt skabelon for at udfylde behandlings- og spørgeskemaoplysninger for denne dagbog.",
    reviewTemplate: "Gennemse skabelon",
    reviewTemplateDescription: "Bekræft oplysningerne nedenfor, inden du tilføjer til denne dagbog.",
    confirmAndContinue: "Bekræft og fortsæt",
    notifyPatientTitle: "Underret patient?",
    intervention: "Intervention",
    openingTemplateProcedure: "Åbner din skabelonbehandling...",
    existingQuestionnaires: "Eksisterende spørgeskemaer",
    continueWithAllQuestionnaires: "Fortsæt med alle spørgeskemaer",
    upcomingEntries: "Kommende indtastninger",
    noUpcomingEntries: "Ingen kommende indtastninger.",
    moreEntriesSummary: (count: number) =>
        `... ${count} ${count === 1 ? "yderligere indtastning" : "yderligere indtastninger"} ...`,
    unlocks: (date: string) => `Låses op ${date}`,
    diaryEnded: "Dagbog afsluttet",
    failedToEndDiary: "Kunne ikke afslutte dagbogen",
    tableSettingsSaved: "Tabelindstillinger gemt",
    diaryAlreadyRead: "Dagbog allerede læst",
    diaryReviewedSubject: "Dagbog gennemset",
    newDiary: "Ny dagbog",
    searchTemplatesPlaceholder: "Søg efter behandling, område eller spørgeskema...",
    noTemplatesYet: "Du har endnu ingen skabeloner. Opret en for at begynde at invitere patienter.",
    noTemplatesMatch: "Ingen skabeloner matcher din søgning.",
    searchTemplatesShort: "Søg skabeloner...",
    procedureFilterInjection: "Injektion",
    procedureFilterSurgery: "Operation",
    procedureFilterShockwave: "Stødbehandling",
    procedureFilterConsultation: "Konsultation",
    procedureFilterProduct: "Produkt",
    checkingActiveQuestionnaires: "Kontrollerer aktive spørgeskemaer...",
    stopQuestionnairesDescription: "Stop spørgeskemaer, inden du tilføjer et nyt, eller fortsæt med alle aktive.",
    noActiveQuestionnairesDescription: "Ingen aktive spørgeskemaer. Fortsæt for at tilføje et nyt.",
    stopping: "Stopper...",
    stopAllCurrentQuestionnaires: "Stop alle aktive spørgeskemaer",
    stopOnly: (name: string) => `Stop kun ${name}`,
    stopJoined: (list: string) => `Stop ${list}`,
    stopTrackerAria: (name: string) => `Stop ${name}`,
    checkingActiveBeforeTemplate: "Kontrollerer aktive spørgeskemaer, inden du bekræfter skabelonen...",
    templateExistingTrackersDescription:
        "Markér dem, du vil stoppe, inden du tilføjer fra denne skabelon, eller fortsæt med alle aktive spørgeskemaer.",
    newPatientDiary: "Ny patientdagbog",
    newPatientDiaryDescription: "Vælg en skabelon, gennemse opsætningen, og inviter derefter din patient.",
    createTemplate: "Opret en skabelon",
    favourites: "Favoritter",
    allTemplates: "Alle skabeloner",
    needFiltersHint: "Brug for filtre eller skabelonadministration?",
    browseAllTemplates: "Gennemse alle skabeloner",
    cc: "Cc",
    saving: "Gemmer...",
    interventionTypeQuestion: "Hvilken type intervention?",
    selectInterventionRequired: "Vælg venligst en interventionstype",
    questionnairesLabel: "Spørgeskemaer",
    continueLabel: "Fortsæt",
    notifyPatientUpdatedDescription:
        "Skabelonen er tilføjet til dagbogen. Vil du sende patienten en besked om opdateringen?",
    noJustFinish: "Nej, afslut blot",
    yesNotifyPatient: "Ja, underret patient",
    diaryUpdatedFromTemplate: "Dagbog opdateret fra skabelon",
    couldNotApplyTemplate: "Kunne ikke anvende skabelon",
    updateMessageTitle: "Send besked til patient?",
    updateMessageDescription: "Send en besked til patienten efter gem.",
    noJustSave: "Nej, gem bare",
    yesSendMessage: "Ja, send en besked",
    saveAndMessagePatient: "Gem og send besked til patient",
    saveOnly: "Gem",
    updateQuestionnairesTitle: "Spørgeskemaer",
    updateQuestionnairesDescription: "Vælg spørgeskemaer og tidsplaner til opfølgning",
    selectQuestionnaire: "Vælg spørgeskema",
    selectQuestionnaireHelp: "Hvilke spørgsmål skal patienten besvare?",
    selectSchedule: "Vælg tidsplan",
    selectScheduleHelp: "Hvornår skal patienten udfylde spørgeskemaet?",
    addAnotherQuestionnaire: "Tilføj endnu et spørgeskema",
    continueWithoutQuestionnaires: "Fortsæt uden spørgeskemaer",
    referenceDateTitle: "Dato",
    referenceDateDescription: "Angiv datoen for hvornår behandlingen eller opfølgningsperioden starter.",
    contactStepDescription: "Hvem er kontaktpersonen?",
    questionnaireWithIndex: (index: number) => `Spørgeskema ${index}`,
    setFlag: "Sæt markering",
    editStatus: "Rediger status",
    setFlagTitle: "Rediger status",
    setFlagDescription: "Dette erstatter den automatiske status, indtil du giver dagbogen tilbage.",
    flagOnTrack: "På sporet",
    flagImproved: "Forbedret",
    flagWorsening: "Forværret igen",
    flagNotImproving: "Ingen bedring",
    flagNoteLabel: "Note",
    flagNotePlaceholder: "Valgfri intern note",
    saveFlag: "Gem status",
    resumeAutomatic: "Genoptag automatisk status",
    resumeAutomaticHint: "Status beregnes igen ud fra patientens registreringer.",
    setManually: "Sat manuelt",
    setManuallyBy: (name) => `Sat af ${name}`,
    teamRecordTitle: "Teamlog",
    teamRecordPrivate: "Kun synlig for klinikere og administratorer. Patienter ser det aldrig.",
    notesTitle: "Noter (deles ikke med patienten)",
    notesDescription: "Interne noter (deles ikke med patienten)",
    noteByline: (author, when) => `Af ${author} ${when}`,
    noteJustNow: "nu",
    addNote: "Tilføj note",
    notePlaceholder: "Skriv en intern note",
    saveNote: "Gem note",
    editNote: "Rediger",
    addNoteName: "Tilføj et navn",
    noteNameLabel: "Navn",
    saveNoteEdit: "Gem",
    deleteNote: "Slet",
    deleteNoteTitle: "Slet note",
    deleteNoteConfirm: "Denne note bliver fjernet. Det kan ikke fortrydes.",
    noteDeleted: "Note slettet",
    couldNotDeleteNote: "Noten kunne ikke slettes",
    cancelNoteEdit: "Annuller",
    noteEdited: "Redigeret",
    statusChangedTo: "Status ændret til",
    statusSetVerb: "satte",
    statusResumed: (name) => `${name} gav dagbogen tilbage til automatisk status`,
    noTeamRecord: "Ingen statusændringer endnu.",
    couldNotSaveFlag: "Markeringen kunne ikke gemmes",
    couldNotSaveNote: "Noten kunne ikke gemmes",
    flagSaved: "Markering gemt",
    noteSaved: "Note gemt",
};
